export const GROUP_USER = {
  VENDOR: 'Fayven-Vendor',
  VENUE: 'Fayven-Venue',
  OWNER_VENDOR: 'Fayven-Vendor-Owner',
  OWNER_VENUE: 'Fayven-Venue-Owner',
  ADMIN: 'Fayven-Admin',
};
